import React from 'react'
import { makeStyles } from '@material-ui/styles';
import { Typography, Grid, Card } from '@material-ui/core';
import SimpleSwitch from './SimpleSwitch';
import LabelledSwitch from './LabelledSwitch';
import FormGroupSwitch from './FormGroupSwitch';
import CustomizedSwitch from './CustomizedSwitch';
import PlacingSwitchLabel from './PlacingSwitchLabel'

const useStyles = makeStyles(theme => ({

    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
    },
    gridContainerOuter: {
        margin: '6px -6px',
        display: 'flex',
        justifyContent: 'center'
    },
    gridItemInner: {
        padding: '3px 6px',
        width: '100%'
    },
    titleDiv: {
        padding: '8px 0px 12px 0px'
    },
    divTitle: {
        padding: 14,
        borderBottom: '1px solid lightgrey'
    },
    divContent: {
        padding: 12,
    },
    cardBody: {
        height: '100%'
    }
}));

function SwitchComp() {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <div className={classes.titleDiv}>
                <Typography variant="h2">switches</Typography>
            </div>
            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} md={6} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Basic switches
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <SimpleSwitch />
                        </div>
                    </Card>
                </Grid>
                <Grid item xs={12} md={6} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Switch with FormControlLabel
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <LabelledSwitch />
                        </div>
                    </Card>
                </Grid>

            </Grid>

            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} md={6} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Switches with FormGroup
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <FormGroupSwitch />
                        </div>
                    </Card>
                </Grid>
                <Grid item xs={12} md={6} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Customized switches
                            </Typography>
                        </div>
                        <div className={classes.divContent} style={{ padding: 18 }}>
                            <CustomizedSwitch />
                        </div>
                    </Card>
                </Grid>

            </Grid>

            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Label placement
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <PlacingSwitchLabel />
                        </div>
                    </Card>
                </Grid>

            </Grid>


        </div>

    )
}

export default SwitchComp
